import { createFileRoute } from "@tanstack/react-router";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { EmailChangeTemplate } from "~/features/myProfile/EmailChangeTemplate";

export const Route = createFileRoute("/_authenticated/profile/email")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(myProfileQueryOptions),
  component: EmailChangeTemplate,
});
